import axios from 'axios';

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? (process.env.REACT_APP_API_URL || 'https://api.prepstop.com')
  : '';

interface DispenseRequest {
  patientId: number;
  prescriptionId?: string;
  dispenseId?: string;
  medicationType?: 'ORAL' | 'INJECTABLE' | 'DOXYPEP';
  medicationName?: string;
  quantity?: number;
  daysSupply?: number;
  dispenseDate: string;
  courseNumber?: number;
  trackingNumber?: string;
  location?: string;
  notes?: string;
  source?: string;
  metadata?: {
    trackingNumber?: string;
    pharmacy?: string;
    ndc?: string;
    [key: string]: any;
  };
}

interface LifecycleEvent {
  id: number;
  patientId: number;
  eventType: string;
  eventDate: string;
  source: string;
  prescriptionId?: string;
  dispenseId?: string;
  medicationType?: string;
  medicationName?: string;
  quantity?: number;
  daysSupply?: number;
  metadata?: any;
  createdAt: string;
}

class MedicationManagementService {
  private getAuthHeaders() {
    const token = localStorage.getItem('authToken');
    return {
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      withCredentials: true,
    };
  }

  async recordDispense(data: DispenseRequest) {
    // Route to appropriate endpoint based on medication type
    if (data.medicationType === 'DOXYPEP' || data.courseNumber) {
      // Use DoxyPEP-specific endpoint
      const response = await axios.post(`${API_BASE_URL}/api/medication-management/doxypep/dispense`, {
        patientId: data.patientId,
        courseNumber: data.courseNumber,
        dispenseDate: data.dispenseDate,
        trackingNumber: data.trackingNumber || data.metadata?.trackingNumber,
        location: data.location,
        notes: data.notes || data.metadata?.notes
      }, this.getAuthHeaders());
      return response.data;
    } else {
      // Use generic dispense endpoint for PrEP
      const response = await axios.post(`${API_BASE_URL}/api/medication-management/dispense`, data, this.getAuthHeaders());
      return response.data;
    }
  }

  async getPatientEvents(patientId: number): Promise<LifecycleEvent[]> {
    const response = await axios.get(`${API_BASE_URL}/api/medication-management/patients/${patientId}/events`, this.getAuthHeaders());
    return response.data.events || [];
  }

  async getPatientStatus(patientId: number) {
    const response = await axios.get(`${API_BASE_URL}/api/medication-management/patients/${patientId}/status`, this.getAuthHeaders());
    return response.data;
  }
}

export default new MedicationManagementService();
